import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class PrivateHeaderSearchService {
	private readonly searchSubject$ = new BehaviorSubject<string>('');
	private readonly searchTerm$ = this.searchSubject$.asObservable();

	public setSearchTerm(term: string) {
		if (this.searchSubject$.value === term) {
			return;
		}

		this.searchSubject$.next(term);
	}

	public getSearchTerm(): string {
		return this.searchSubject$.value;
	}

	public clearSearchTerm(): void {
		this.setSearchTerm('');
	}

	public onSearchTermChange() {
		return this.searchTerm$;
	}
}
